import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Layout } from "./components/Layout";
import Login from "./pages/Login";
import Register from "./pages/Register";
import SetPin from "./pages/SetPin";
import Dashboard from "./pages/Dashboard";
import TransferHub from "./pages/TransferHub";
import TransferBank from "./pages/TransferBank";
import TransferUser from "./pages/TransferUser";
import TopUp from "./pages/TopUp";
import Qris from "./pages/Qris";
import History from "./pages/History";
import TransactionDetail from "./pages/TransactionDetail";
import BankAccounts from "./pages/BankAccounts";
import Profile from "./pages/Profile";
import DevTools from "./pages/DevTools";

const FullLoader = () => (
  <div className="min-h-dvh flex items-center justify-center bg-background">
    <div className="flex flex-col items-center gap-3">
      <div className="h-10 w-10 rounded-full border-4 border-primary/20 border-t-primary animate-spin" />
      <p className="text-sm text-muted-foreground">Memuat...</p>
    </div>
  </div>
);

function Protected({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <FullLoader />;
  if (!user) return <Navigate to="/masuk" replace />;
  if (!user.has_pin && location.pathname !== "/atur-pin") return <Navigate to="/atur-pin" replace />;
  return children;
}

function GuestOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <FullLoader />;
  if (user) return <Navigate to={user.has_pin ? "/" : "/atur-pin"} replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/masuk" element={<GuestOnly><Login /></GuestOnly>} />
            <Route path="/daftar" element={<GuestOnly><Register /></GuestOnly>} />
            <Route path="/atur-pin" element={<Protected><SetPin /></Protected>} />
            <Route element={<Protected><Layout /></Protected>}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/transfer" element={<TransferHub />} />
              <Route path="/transfer/bank" element={<TransferBank />} />
              <Route path="/transfer/pengguna" element={<TransferUser />} />
              <Route path="/top-up" element={<TopUp />} />
              <Route path="/qris" element={<Qris />} />
              <Route path="/riwayat" element={<History />} />
              <Route path="/transaksi/:id" element={<TransactionDetail />} />
              <Route path="/rekening" element={<BankAccounts />} />
              <Route path="/profil" element={<Profile />} />
              <Route path="/dev-tools" element={<DevTools />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
